import { AutogenModelJournalDriver, AutogenRowJournalDriver } from "./autogen/AutogenModelJournalDriver";

export class ModelJournalDriver extends AutogenModelJournalDriver<RowJournalDriver> {
	constructor() {
		super(RowJournalDriver);
	}
}

export class RowJournalDriver extends AutogenRowJournalDriver {
}